import { useNavigate } from "@tanstack/react-router";
import { useCallback, type MouseEvent as ReactMouseEvent } from "react";

import { getRevealHref, navigateAndReveal } from "@/lib/navigation/navigate-and-reveal";

function marketplaceOrderReveal(orderId: string, orderScriptId: string | undefined) {
  return {
    route: "/marketplace" as const,
    targetId: orderScriptId ?? orderId,
    search: {
      tab: "in-production" as const,
      order: orderId,
      script: orderScriptId,
    },
  };
}

export function marketplaceOrderHref(orderId: string, orderScriptId: string | undefined): string {
  return getRevealHref(marketplaceOrderReveal(orderId, orderScriptId));
}

/** Opens the marketplace in-production order a sent script or brief belongs to. */
export function useOpenMarketplaceOrder() {
  const navigate = useNavigate();
  return useCallback(
    (orderId: string, orderScriptId: string | undefined, event: ReactMouseEvent<HTMLAnchorElement>) => {
      const target = marketplaceOrderReveal(orderId, orderScriptId);
      void navigateAndReveal({
        ...target,
        event,
        navigate: () =>
          navigate({
            to: "/marketplace",
            search: {
              tab: "in-production",
              order: orderId,
              ...(orderScriptId ? { script: orderScriptId } : {}),
            },
          }),
      });
    },
    [navigate],
  );
}
